import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class ZipInCardStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing, color } = options.theme;
        return css `
			${Text.CSS}

			:host {
				display: flex;
				flex-direction: column;
				height: 100%;
			}

			h2 {
				margin-top: 0;
			}

			skapa-input-field {
				display: flex;
				flex-direction: column;
				font-family: inherit;
			}

			label {
				color: ${color.text.default};
			}

			skapa-inline-message {
				margin-top: ${spacing.space250 / 16}rem;
			}

			input {
				font-family: inherit;
			}

			.visuallyHidden:not(:focus):not(:active) {
				clip: rect(0 0 0 0);
				clip-path: inset(50%);
				height: ${1 / 16}rem;
				overflow: hidden;
				position: absolute;
				white-space: nowrap;
				width: ${1 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=ZipInCardStyle.js.map